module.exports = __webpack_public_path__ + "img/slide-3.d45f5bb5.jpg";